import { defineThemeValue, ThemeDefinitionFactory } from './defineThemeValue';

/**
 * Create a theme definition for shadows
 *
 * @param themeDependentValue A tuple where the first element represents a bluestar value and the second is the dark mode value
 */
export const defineShadow = defineThemeValue as ThemeDefinitionFactory<string>;
